module.exports = __webpack_public_path__ + "img/bread_disp.01be784a.jpg";